class RouteConstants {
  public static readonly PATH_ROOT: string = '/';

  public static readonly PATH_REGISTER: string = 'registreren';

  public static readonly PATH_REGISTER_OFFICEMANAGERS: string = 'officemanagers';

  public static readonly PATH_OFFICES: string = 'kantoren';

  public static readonly PATH_COMPANIES: string = 'bedrijven';

  public static readonly PATH_REGISTER_EMPLOYEES: string = 'medewerkers-aanmelden';

  public static readonly PATH_STATISTICS: string = 'statistieken';

  public static readonly PATH_DASHBOARD: string = 'dashboard';

  /**
   * The unauthenticated kiosk/TV screen route for the Displays feature. Deliberately NOT
   * registered in routes.tsx (which renders inside the Keycloak-authenticated shell) — it is
   * matched directly in index.tsx, before KeycloakProvider mounts, so it never triggers a
   * login-required redirect. The screen identifies itself via a paired X-Display-Token instead.
   */
  public static readonly PATH_DISPLAY_SCREEN: string = 'scherm';

  /**
   * The unauthenticated public screen route for a facility display. Same reasoning as
   * PATH_DISPLAY_SCREEN: matched in index.tsx, never registered in routes.tsx.
   */
  public static readonly PATH_FACILITY_DISPLAY_SCREEN: string = 'scherm-facility';

  /** The floorplan editor, scoped to one office: /kantoren/:id/plattegrond. */
  public static readonly PATH_FLOORPLAN_EDITOR: string = '/plattegrond';

  public static readonly PATH_CREATE: string = '/creëer';

  public static readonly PATH_DASHBOARD_OFFICES: string = '/kantoren';

  public static readonly PATH_DASHBOARD_USERS: string = '/gebruikers';

  public static readonly PATH_EDIT: string = '/:id';

  public static readonly PATH_EMAIL: string = '/:email';

  public static readonly PATH_TOKEN: string = '/:token';
}

export default RouteConstants;
